import { environment } from "src/environments/environment";
import { BusinessData } from "./BusinessData.interface";

export const INITIAL_BUSINESS_DATA: BusinessData = (environment.mock && environment.mockBusinessData) ? {
    companyName: "Zottel GmbH",
    invoiceStreetAddress: "Ittersdorfer Str 36",
    invoicePostalCode: "66802",
    invoiceCity: "Überherrn",
    contactEmail: "thorsten.schemel@gmail.com",
    contactEmailConfirmation: "thorsten.schemel@gmail.com",
    invoiceAgreementNumber: "ABC123",
    invoiceReference: "XYZ666"
  } : {
    companyName: "",
    invoiceStreetAddress: "",
    invoicePostalCode: "",
    invoiceCity: "",
    contactEmail: "",
    contactEmailConfirmation: "",
    invoiceAgreementNumber: "",
    invoiceReference: ""
}
